import { FormsModule } from '@angular/forms';
import { MbscModule } from '@mobiscroll/angular';
/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {APP_INITIALIZER, NgModule} from '@angular/core';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {CoreModule} from './@core/core.module';
import {ThemeModule} from './@theme/theme.module';
import {AppComponent} from './app.component';
import {AppRoutingModule} from './app-routing.module';
import {
  NbChatModule,
  NbDatepickerModule,
  NbDialogModule,
  NbMenuModule,
  NbSidebarModule,
  NbToastrModule,
  NbWindowModule,
} from '@nebular/theme';
import {NB_AUTH_TOKEN_INTERCEPTOR_FILTER} from '@nebular/auth';
import {APP_BASE_HREF} from '@angular/common';
import {AgmCoreModule} from '@agm/core';
import {environment} from '../environments/environment';
import {MessagingService} from './@core/utils/messaging.service';
import {ConstantsService} from './@core/utils/constants.service';
import {AuthGuard, AuthService, DataService, OrderService, RoleProvider, UserService} from './@core/utils';
import {AngularFireMessaging, AngularFireMessagingModule} from "@angular/fire/compat/messaging";
import {AngularFireStorageModule} from "@angular/fire/compat/storage";
import {AuthModule} from "@angular/fire/auth";
import {AngularFireModule} from "@angular/fire/compat";
import {ServiceWorkerModule} from "@angular/service-worker";
import {Interceptor} from "./config/http.interceptor";
export function ConstantsServiceFactory(constantsService: ConstantsService): any {
  return async () => {
    await constantsService.init();
  };
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    FormsModule,
    MbscModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFireMessagingModule,
    AngularFireStorageModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyBkr7_iamVHJB50B4G1zpwrbSjX3GjTgvI',
      language: 'en',
      libraries: ['geometry', 'places'],
    }),
    ThemeModule.forRoot(),

    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot(),
    NbChatModule.forRoot({
      messageGoogleMapKey: 'AIzaSyA_wNuCzia92MAmdLRzmqitRGvCF7wCZPY',
    }),
    CoreModule.forRoot(),
    AuthModule,
    ServiceWorkerModule.register('ngsw-worker.js', {enabled: true}),
  ],
  bootstrap: [AppComponent],
  providers: [
    AuthService,
    AuthGuard,
    DataService,
    UserService,
    RoleProvider,
    MessagingService,
    OrderService,
    AngularFireMessaging,
    {provide: HTTP_INTERCEPTORS, useClass: Interceptor, multi: true},
    {
      provide: NB_AUTH_TOKEN_INTERCEPTOR_FILTER, useValue: function () {
        return false;
      },
    },
    {provide: APP_BASE_HREF, useValue: '/'},
    {provide: APP_INITIALIZER, deps: [ConstantsService], multi: true, useFactory: ConstantsServiceFactory},

  ],
})
export class AppModule {
}
